import { ATTRS, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity, ISOFileInformation } from '../types';
import { parseXMLAttributes, encodeXMLAttributes } from '../time';
import { DataLogValueEntity } from './DataLogValue';

export class TimeEntity implements Entity {
  public static fromXML(
    xml: any,
    matchIDs: any,
    files: ISOFileInformation[],
    entitiesManager: EntitiesManager
  ) {
    const attrs = xml._attributes;
    const { start, stop, duration } = parseXMLAttributes(
      attrs[ATTRS.Time.Start],
      attrs[ATTRS.Time.Stop],
      attrs[ATTRS.Time.Duration],
      entitiesManager.options.version
    );
    const timeType = attrs[ATTRS.Time.Type];

    const dataLogValues: DataLogValueEntity[] = (xml[TAGS.DataLogValue] || []).map(
      (dlvXml) => DataLogValueEntity.fromXML(dlvXml).entity
    );
    return {
      entity: new TimeEntity(timeType, start, stop, duration, dataLogValues),
    };
  }

  public type = TAGS.Time;

  constructor(
    public timeType: string,
    public start: number, // timestamp in milliseconds
    public stop: number = null, // timestamp in milliseconds
    public duration: number = null, // seconds
    public dataLogValues: DataLogValueEntity[] = []
  ) {
    if (duration && !stop) {
      this.stop = start + duration * 1000;
    }

    if (stop && !duration) {
      this.duration = Math.round((stop - start) / 1000);
    }
  }

  public toXML(xmlId: string, entitiesManager: EntitiesManager) {
    const { startStr, stopStr, durationStr } = encodeXMLAttributes(
      this.start,
      this.stop,
      this.duration,
      entitiesManager.options.version
    );

    return {
      _attributes: {
        [ATTRS.Time.Start]: startStr,
        ...(stopStr && { [ATTRS.Time.Stop]: stopStr }),
        ...(durationStr && { [ATTRS.Time.Duration]: durationStr }),
        [ATTRS.Time.Type]: this.timeType,
      },
      [TAGS.DataLogValue]: (this.dataLogValues || []).map((dataLogValueEntity) =>
        dataLogValueEntity.toXML()
      ),
    };
  }
}
